export { default } from './SalaryGuide';
